import BackgroundLight from './background-light';

export default BackgroundLight;
